module.exports = __webpack_public_path__ + "static/img/image-upload.ff61079.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image-upload.jpg
// module id = jDY5
// module chunks = 1